import React from "react";

export const ReviewStatusCell = ({ row, value }) => {
  const needsReview = Boolean(value);

  return <>{needsReview ? "Needs Review" : "Reviewed"}</>;
};
